import { useSelector } from "react-redux";
import { RootState } from "rootReducer";
import { Wrapper, Container, Heading, UL, LI, A, LinkText, MobileContainer, MobileHeading } from "./QuickLinksStyles";

const QuickLinks = () => {
  const { screenSize, quickLinks } = useSelector((state: RootState) => state.State);
  const userHasAccessToLinkForDriftAndForvaltning = useSelector(
    (state: RootState) => state.State.userAccessToDriftAndForvaltningLink
  );

  if (screenSize.width > 950) {
    return (
      <Wrapper>
        <Container>
          <Heading>Snabblänkar</Heading>
          <UL>
            {userHasAccessToLinkForDriftAndForvaltning && (
              <LI>
                <A href="http://logp.fmv.se/tjansterprodukter/driftochforvaltning/Sidor/default.aspx" target="_blank">
                  <LinkText>Till Drift och förvaltning</LinkText>
                </A>
              </LI>
            )}
            {quickLinks
              .filter(link => link.Active)
              .map(link => {
                return (
                  <LI key={link.Id}>
                    <A href={link.Link} rel="noreferrer" target={link.OpenInNewTab ? "_blank" : ""}>
                      <LinkText>{link.Title}</LinkText>
                    </A>
                  </LI>
                );
              })}
          </UL>
        </Container>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper>
        <MobileContainer>
          <MobileHeading>Snabblänkar</MobileHeading>
          <UL>
            {quickLinks
              .filter(link => link.Active)
              .map(link => {
                return (
                  <LI key={link.Id}>
                    <A href={link.Link} rel="noreferrer" target={link.OpenInNewTab ? "_blank" : ""}>
                      <LinkText>{link.Title}</LinkText>
                    </A>
                  </LI>
                );
              })}
          </UL>
        </MobileContainer>
      </Wrapper>
    );
  }
};

export default QuickLinks;
